
export default {
  CASCO_ALTO: {
    CANTOS: {
      BASE: {
        op1: "1 largo",
        op2: "2 largos",
      },
      COSTADO: {
        op1: "1 largo y 1 corto",
        op2: "1 largo y 2 cortos",
        op3: "2 largos y 2 cortos",
      },
      TECHO: {
        op1: "1 largo",
        op2: "2 largos",
      },
      BALDA: {
        op1: "1 largo",
        op2: "2 largos",
        op3: "2 largos y 2 cortos"
      },
      DIVISOR: {
        op1: "1 largo"
      },
      TRASERA: {
        op1: "Sin cantear",
        op2: "1 largo",
        op3: "2 largos",
        op4: "1 corto",
        op5: "2 cortos",
        op6: "1 largo y 1 corto",
        op7: "1 largo y 2 cortos",
        op8: "2 largos y 1 corto",
        op9: "2 largos y 2 cortos"
      }
    }
  },
  CASCO_BAJO: {
    CANTOS: {
      BASE: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "1 largo y 2 cortos",
        op4: "2 largos y 2 cortos"
      },
      COSTADO: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 1 corto"
      },
      TECHO: {
        op1: "1 largo",
        op2: "2 largos"
      },
      BALDA: {
        op1: "1 largo",
        op2: "2 largos",
        op3: "2 largos y 2 cortos"
      },
      DIVISOR: {
        op1: "1 largo"
      },
      TRASERA: {
        op1: "Sin cantear",
        op2: "1 largo",
        op3: "2 largos",
        op4: "1 corto",
        op5: "2 cortos",
        op6: "1 largo y 1 corto",
        op7: "1 largo y 2 cortos",
        op8: "2 largos y 1 corto",
        op9: "2 largos y 2 cortos"
      }
    }
  },
  RINCON: {
    REGLETA_ANCHURA: 10, // cm
    CANTOS: {
      BASE_MAYOR: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 2 cortos"
      },
      BASE_MENOR: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 1 corto"
      },
      COSTADO: {
        op1: "1 largo",
        op2: "2 largos y 1 corto"
      },
      TECHO_MAYOR: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 2 cortos"
      },
      TECHO_MENOR: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 1 corto"
      },
      BALDA_MAYOR: {
        op1: "1 largo",
        op2: "2 largos",
        op3: "2 largos y 2 cortos"
      },
      BALDA_MENOR: {
        op1: "1 largo",
        op2: "2 largos",
        op3: "2 largos y 1 corto"
      },
      REGLETA: {
        op1: "2 largos"
      },
      TRASERA: {
        op1: "Sin cantear",
        op2: "1 largo",
        op3: "2 largos",
        op4: "1 corto",
        op5: "2 cortos",
        op6: "1 largo y 1 corto",
        op7: "1 largo y 2 cortos",
        op8: "2 largos y 1 corto",
        op9: "2 largos y 2 cortos"
      }
    }
  },
  FREGADERO: { 
    BARRA_ALTURA: 8, // cm
    TOPE_ALTURA: 5, // cm
    CANTOS: {
      BASE: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "1 largo y 2 cortos",
        op4: "2 largos y 2 cortos"
      },
      COSTADO: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 1 corto"
      },
      BARRA: {
        op1: "2 largos"
      },
      TOPE: {
        op1: "1 largo"
      }
    }
  },
  PLACA: { 
    BARRA_ALTURA: 8, // cm
    CANTOS: {
      BASE: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "1 largo y 2 cortos",
        op4: "2 largos y 2 cortos"
      },
      COSTADO: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 1 corto"
      },
      BARRA: {
        op1: "2 largos"
      },
    }
  },
  CAJONERA: { 
    BARRA_ALTURA: 8, // cm
    CANTOS: {
      BASE: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "1 largo y 2 cortos",
        op4: "2 largos y 2 cortos"
      },
      COSTADO: {
        op1: "1 largo",
        op2: "1 largo y 1 corto",
        op3: "2 largos y 1 corto"
      },
      BARRA: {
        op1: "2 largos"
      },
    }
  },
  ESCURREPLATOS: {
    CANTOS: {
      COSTADO: {
        op1: "1 largo y 1 corto",
        op2: "1 largo y 2 cortos",
        op3: "2 largos y 2 cortos"
      },
      TECHO: {
        op1: "1 largo",
        op2: "2 largos"
      },
      BALDA: {
        op1: "1 largo",
        op2: "2 largos",
        op3: "2 largos y 2 cortos"
      },
      TRASERA: {
        op1: "1 corto",
      },
    }
  },
  PIEZA_LIBRE: {
    CANTOS: {
        op1: "Sin cantear",
        op2: "1 largo",
        op3: "2 largos",
        op4: "1 corto",
        op5: "2 cortos",
        op6: "1 largo y 1 corto",
        op7: "1 largo y 2 cortos",
        op8: "2 largos y 1 corto",
        op9: "2 largos y 2 cortos"
    }
  },
  DIVISOR: {
    POSICION: {
        op1: "Vertical",
        op2: "Horizontal"
    },
    AJUSTE: {
        op1: "Enrrasado",
        op2: "Remetido"
    },
  },
}



// WEBPACK FOOTER //
// ./src/data_muebles.js